import React__default from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import { Link as Link$1 } from 'react-router-dom';

var Link = function Link(_a) {
  var to = _a.to,
      children = _a.children,
      props = __rest(_a, ["to", "children"]); // Try to use react router for links within the same domain for a nice SPA transition


  var origin = window.location ? window.location.protocol + "//" + window.location.hostname : '';
  var isInternalLink = window.location && to.startsWith(origin);

  if (isInternalLink) {
    var absolutePath = to.substring(origin.length) || '/';
    return React__default.createElement(Link$1, __assign({
      to: absolutePath
    }, props), children);
  } else {
    return React__default.createElement("a", __assign({
      href: to,
      target: "_blank"
    }, props), children);
  }
};

export default Link;
//# sourceMappingURL=index.js.map
